import React, { useState } from 'react';

const SongList = ({ songs, loading, onDelete }) => {
  const [sortBy, setSortBy] = useState('title');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filterBy, setFilterBy] = useState('all');

  const formatDuration = (seconds) => {
    if (!seconds) return 'Unknown';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    return new Date(dateString).toLocaleString();
  };

  const handleDelete = async (songId, songTitle) => {
    if (window.confirm(`Are you sure you want to delete "${songTitle}"?`)) {
      await onDelete(songId);
    }
  };

  const sortedAndFilteredSongs = songs
    .filter(song => {
      if (filterBy === 'played') return song.play_count > 0;
      if (filterBy === 'unplayed') return song.play_count === 0;
      return true;
    })
    .sort((a, b) => {
      let aVal, bVal;
      
      switch (sortBy) {
        case 'title':
          aVal = a.title.toLowerCase();
          bVal = b.title.toLowerCase();
          break;
        case 'play_count':
          aVal = a.play_count;
          bVal = b.play_count;
          break;
        case 'last_played':
          aVal = new Date(a.last_played || 0);
          bVal = new Date(b.last_played || 0);
          break;
        case 'created_at':
          aVal = new Date(a.created_at);
          bVal = new Date(b.created_at);
          break;
        default:
          aVal = a.title.toLowerCase();
          bVal = b.title.toLowerCase();
      }
      
      if (sortOrder === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });

  if (loading && songs.length === 0) {
    return (
      <div className="song-list">
        <div className="loading">Loading songs...</div>
      </div>
    );
  }

  return (
    <div className="song-list">
      <div className="song-list-header">
        <h2>Songs ({songs.length})</h2>
        
        <div className="song-list-controls">
          <div className="filter-controls">
            <label>Filter:</label>
            <select 
              value={filterBy} 
              onChange={(e) => setFilterBy(e.target.value)}
            >
              <option value="all">All Songs</option>
              <option value="played">Played</option>
              <option value="unplayed">Unplayed</option>
            </select>
          </div>
          
          <div className="sort-controls">
            <label>Sort by:</label>
            <select 
              value={sortBy} 
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="title">Title</option>
              <option value="play_count">Play Count</option>
              <option value="last_played">Last Played</option>
              <option value="created_at">Date Added</option>
            </select>
            <button 
              className="sort-order-btn"
              onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
            >
              {sortOrder === 'asc' ? '↑' : '↓'}
            </button>
          </div>
        </div>
      </div>

      <div className="songs-table">
        <div className="table-header">
          <div className="col-title">Title</div>
          <div className="col-duration">Duration</div>
          <div className="col-plays">Plays</div>
          <div className="col-last-played">Last Played</div>
          <div className="col-actions">Actions</div>
        </div>
        
        <div className="table-body">
          {sortedAndFilteredSongs.map(song => (
            <div key={song.id} className="table-row">
              <div className="col-title">
                <div className="song-title">{song.title}</div>
                <div className="song-filename">{song.created_at}</div>
              </div>
              <div className="col-duration">
                {formatDuration(song.duration_seconds)}
              </div>
              <div className="col-plays">
                <span className={`play-count ${song.play_count > 0 ? 'played' : 'unplayed'}`}>
                  {song.play_count}
                </span>
              </div>
              <div className="col-last-played">
                {formatDate(song.last_played)}
              </div>
              <div className="col-actions">
                <button 
                  className="delete-btn"
                  onClick={() => handleDelete(song.id, song.title)}
                  disabled={loading}
                  title="Delete song"
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {sortedAndFilteredSongs.length === 0 && (
        <div className="no-songs">
          <p>No songs found matching the current filter.</p>
        </div>
      )}
    </div>
  );
};

export default SongList;
